// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import * as TastyBurgerButton from 'vue-tasty-burgers'
import 'vue-tasty-burgers/dist/vue-tasty-burgers.css'
import Common from 'Common/components/index-site'
import VAnimateCss from 'v-animate-css'
import VueScrollTo from 'vue-scrollto'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import BackToTop from 'vue-backtotop'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Components from '@/components'
import 'Css/main.less'
import commonServices from 'Common/services'
import e24SiteServices from 'CommonSite/services'
import Notifications from 'vue-notification'
import store from './store'

Vue.use(VueResource)
Vue.use(Notifications)
Vue.use(commonServices)
Vue.use(e24SiteServices)
library.add(faCoffee)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(Components)
Vue.use(BackToTop)
Vue.use(VueMaterial)
Vue.use(BootstrapVue)
Vue.use(Common)
Vue.use(TastyBurgerButton, { prefix: 'abc' })
Vue.use(VAnimateCss)
Vue.use(VueScrollTo, {
	container: 'body',
	duration: 500,
	easing: 'ease',
	offset: 0,
	force: true,
	cancelable: true,
	onStart: false,
	onDone: false,
	onCancel: false,
	x: false,
	y: true
})
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	router,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js